import { useContext, useEffect, useState } from "react";

import { Formik } from "formik";
import moment from "jalali-moment";
import _ from "lodash";
import { useParams } from "react-router";
import Select from "react-select";
import * as Yup from "yup";

import { EventContext } from "../../../Contexts/EventContext";
import Datepicker from "../../../Shared/Components/Datepicker";
import ErrorMessage from "../../../Shared/Components/ErrorMessage";
import Loading from "../../../Shared/Components/Loading";
import TextEditor from "../../../Shared/Components/TextEditor";
import { error, success } from "../../../Shared/Components/Toast";
import useApi from "../../../Shared/hooks/api/Index";
import { number_format, showFirstRequestError } from "../../../Shared/utils/helper";
/** @format */
import Master from "../../Layouts/Master";

const validationSchema = Yup.object().shape({
  title: Yup.string()
    .required("عنوان الزامی است")
    .max(190, "عنوان نمیتواند بیشتر از 190 کاراکتر باشد"),
  match_style_id: Yup.number()
    .typeError("سبک مسابقه الزامی است")
    .required("سبک مسابقه الزامی است"),
  match_kinds: Yup.array()
    .typeError("نوع مسابقه الزامی است")
    .min(1, "نوع مسابقه الزامی است")
    .max(1, "فقط یک نوع مسابقه مجاز است"),
  province: Yup.number()
    .typeError("استان الزامی است")
    .required("استان الزامی است"),
  city: Yup.number().typeError("شهر الزامی است").required("شهر الزامی است"),
  register_start: Yup.string().required("شروع ثبت نام الزامی است"),
  register_end: Yup.string().required("پایان ثبت نام الزامی است"),
  start: Yup.string().required("شروع برگزاری الزامی است"),
  end: Yup.string().required("پایان برگزاری الزامی است"),
  allowed_person: Yup.number()
    .typeError("ظرفیت الزامی است")
    .required("ظرفیت الزامی است"),
  gender: Yup.number()
    .typeError("جنسیت الزامی است")
    .required("جنسیت الزامی است"),
  address: Yup.string()
    .nullable()
    .max(500, "آدرس نمیتواند بیشتر از 500 کاراکتر باشد"),
  description: Yup.string().nullable(),
});

const EditMatch = () => {
  const { id } = useParams();
  const eventContext = useContext(EventContext);
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [, setLoadMatchKind] = useState(false);
  const [, setLoadCity] = useState(false);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState([]);
  const [matchStyle, setMatchStyle] = useState([]);
  //One
  const [ages, setAges] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [ageId, setAgeId] = useState("");
  const [price, setPrice] = useState("");
  const [ageTitle, setAgeTitle] = useState("");
  const [provinceId, setProvinceId] = useState("");
  const [provinceTitle, setProvinceTitle] = useState("");
  const [errorAge, setErrorAge] = useState(false);
  const [, setPosts] = useState([]);

  //Team
  const [agesTeam, setAgesTeam] = useState([]);
  const [provincesTeam, setProvincesTeam] = useState([]);
  const [ageIdTeam, setAgeIdTeam] = useState("");
  const [priceTeam, setPriceTeam] = useState("");
  const [ageTitleTeam, setAgeTitleTeam] = useState("");
  const [provinceIdTeam, setProvinceIdTeam] = useState("");
  const [provinceTitleTeam, setProvinceTitleTeam] = useState("");
  const [provinceCountTeam, setProvinceCountTeam] = useState("");
  const [provinceCountPersonTeam, setProvinceCountPersonTeam] = useState("");
  const [errorAgeTeam, setErrorAgeTeam] = useState(false);
  const [postsTeam, setPostsTeam] = useState([]);
  const [errorPostTeam, setErrorPostTeam] = useState(false);
  const [postTitleTeam, setPostTitleTeam] = useState("");
  const [postIdTeam, setPostIdTeam] = useState("");
  const [postCountTeam, setPostCountTeam] = useState("");

  //Double
  const [agesDouble, setAgesDouble] = useState([]);
  const [provincesDouble, setProvincesDouble] = useState([]);
  const [ageIdDouble, setAgeIdDouble] = useState("");
  const [priceDouble, setPriceDouble] = useState("");
  const [ageTitleDouble, setAgeTitleDouble] = useState("");
  const [provinceIdDouble, setProvinceIdDouble] = useState("");
  const [provinceTitleDouble, setProvinceTitleDouble] = useState("");
  const [errorAgeDouble, setErrorAgeDouble] = useState(false);
  const [provinceCountDouble, setProvinceCountDouble] = useState("");
  const [provinceCountPersonDouble, setProvinceCountPersonDouble] = useState(2);
  const [, setPostsDouble] = useState([]);

  useEffect(() => {
    getInfo();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getInfo = async () => {
    setLoading(true);
    await useApi.get(
      "/general/province",
      {},
      (res) => {
        eventContext.provinces = res.data.data;
      },
      (err) => {
        console.log(err);
        error("هنگام دریافت اطلاعات خطایی رخ داده است.");
        setLoading(false);
      }
    );
    await useApi.get(
      "/panel/base/age",
      {},
      (res) => {
        eventContext.ages = res.data.data;
      },
      (err) => {
        console.log(err);
        error("هنگام دریافت اطلاعات خطایی رخ داده است.");
        setLoading(false);
      }
    );
    await useApi.get(
      "/panel/base/post?all=true",
      {},
      (res) => {
        eventContext.posts = res.data.data;
      },
      (err) => {
        console.log(err);
        error("هنگام دریافت اطلاعات خطایی رخ داده است.");
        setLoading(false);
      }
    );
    await useApi.get(
      "/panel/base/match-style?all=1",
      {},
      (res) => {
        eventContext.matchStyles = res.data.data;
      },
      (err) => {
        console.log(err);
        error("هنگام دریافت اطلاعات خطایی رخ داده است.");
        setLoading(false);
      }
    );
    await useApi.get(
      `/panel/match/${id}`,
      {},
      (res) => {
        let match = res.data.data;
        eventContext.match = match;
        setAges(match.match_ages?.single ?? []);
        setAgesTeam(match.match_ages?.team ?? []);
        setAgesDouble(match.match_ages?.double ?? []);
        setProvinces(match.match_allowed_provinces?.single ?? []);
        setProvincesTeam(match.match_allowed_provinces?.team ?? []);
        setPosts(
          match.match_posts?.single?.posts?.length > 0
            ? match.match_posts?.single?.posts
            : []
        );
        setPostsTeam(
          match.match_posts?.team?.posts?.length > 0
            ? match.match_posts?.team?.posts
            : []
        );
        setPostsDouble(
          match.match_posts?.doble?.posts?.length > 0
            ? match.match_posts?.double?.posts
            : []
        );
        setProvincesDouble(match.match_allowed_provinces?.double ?? []);
        setMatchStyle(eventContext.match?.match_style?.id);
        getMatchKindByMatchStyle(eventContext.match?.match_style?.id);
        setType((match.match_kinds || []).slice(0, 1));
        getCities(match.province?.id);
        setLoading(false);
      },
      (err) => {
        console.log(err);
        error("هنگام دریافت اطلاعات خطایی رخ داده است.");
        setLoading(false);
      }
    );
  };

  const getCities = async (provinceId) => {
    setLoadCity(true);
    await useApi.get(
      `/general/city/${provinceId}`,
      {},
      (res) => {
        eventContext.cities = res.data.data;
        setLoadCity(false);
      },
      (err) => {
        console.log(err);
        error("هنگام دریافت اطلاعات خطایی رخ داده است.");
        setLoadCity(false);
      }
    );
  };

  const getMatchKindByMatchStyle = async (matchStyleId) => {
    setLoadMatchKind(true);
    await useApi.get(
      `/panel/base/match-style/${matchStyleId}`,
      {},
      (res) => {
        eventContext.matchKinds = res.data.data?.match_kind;
        setLoadMatchKind(false);
      },
      (err) => {
        console.log(err);
        error("هنگام دریافت اطلاعات خطایی رخ داده است.");
        setLoadMatchKind(false);
      }
    );
  };

  const addAge = () => {
    if (
      price.length === 0 ||
      price === undefined ||
      ageId.length === 0 ||
      ageTitle.length === 0
    ) {
      setErrorAge(true);
      return;
    }

    setErrorAge(false);
    let agesCpy = [...ages];
    const ageIndex = agesCpy.findIndex((a) => a.age_id === ageId);

    if (ageIndex === -1) {
      agesCpy.push({ age_id: ageId, person_price: price, title: ageTitle });
    } else {
      agesCpy[ageIndex]["person_price"] = price;
      agesCpy[ageIndex]["title"] = ageTitle;
    }
    setPrice("");
    setAgeId("");
    setAgeTitle("");
    setAges(agesCpy);
  };
  const addProvince = () => {
    setErrorAge(false);
    let provinceCpy = [...provinces];

    if (provinceId === "all") {
      eventContext.provinces.forEach((item) => {
        const provinceIndex = provinceCpy.findIndex(
          (a) => a.province_id === item.id
        );

        if (provinceIndex === -1) {
          provinceCpy.push({ province_id: item.id, title: item.name });
        } else {
          provinceCpy[provinceIndex]["title"] = item.name;
        }
        removeProvinceOptions("select-age-one", item.id, item.name);
      });
    } else {
      const provinceIndex = provinceCpy.findIndex(
        (a) => a.province_id === provinceId
      );
      if (provinceIndex === -1) {
        provinceCpy.push({ province_id: provinceId, title: provinceTitle });
      } else {
        provinceCpy[provinceIndex]["title"] = provinceTitle;
      }
      removeProvinceOptions("select-age-one", provinceId, provinceTitle);
    }

    // setProvinceId('');
    // setProvinceTitle('');
    setProvinces(provinceCpy);
  };

  const removeProvinceOptions = (tagId, id, name) => {
    let selectProvince = document.getElementById(tagId);
    for (let i = 0; i < selectProvince.length; i++) {
      if (selectProvince.options[i].value === `${id}-${name}`) {
        selectProvince.remove(i);
        selectProvince.options[1].selected = true;
        let val = selectProvince.value.split("-");
        setProvinceId(val[0]);
        setProvinceTitle(val[1]);
      }
    }
  };
  const addAgeTeam = () => {
    if (
      priceTeam.length === 0 ||
      priceTeam === undefined ||
      ageIdTeam.length === 0 ||
      ageTitleTeam.length === 0
    ) {
      setErrorAgeTeam(true);
      return;
    }

    setErrorAge(false);
    let agesCpy = [...agesTeam];
    const ageIndex = agesCpy.findIndex((a) => a.age_id === ageIdTeam);

    if (ageIndex === -1) {
      agesCpy.push({
        age_id: ageIdTeam,
        person_price: priceTeam,
        title: ageTitleTeam,
      });
    } else {
      agesCpy[ageIndex]["person_price"] = priceTeam;
      agesCpy[ageIndex]["title"] = ageTitleTeam;
    }
    setPriceTeam("");
    setAgeIdTeam("");
    setAgeTitleTeam("");
    setAgesTeam(agesCpy);
  };
  const addPostTeam = () => {
    if (
      postIdTeam.length === 0 ||
      postIdTeam === undefined ||
      postCountTeam.length === 0 ||
      postCountTeam.length === 0
    ) {
      setErrorPostTeam(true);
      return;
    }

    setErrorPostTeam(false);
    let postsCopy = [...postsTeam];
    const postIndex = postsCopy.findIndex((a) => a.post_id === postIdTeam);

    if (postIndex === -1) {
      postsCopy.push({
        post_id: postIdTeam,
        title: postTitleTeam,
        count: postCountTeam,
      });
    } else {
      postsCopy[postIndex]["post_id"] = postIdTeam;
      postsCopy[postIndex]["title"] = postTitleTeam;
      postsCopy[postIndex]["count"] = postCountTeam;
    }
    setPostIdTeam("");
    setPostTitleTeam("");
    setPostCountTeam("");
    setPostsTeam(postsCopy);
  };
  const addProvinceTeam = () => {
    setErrorAgeTeam(false);
    let provinceCpy = [...provincesTeam];
    let provinceCountArray = provinceCpy.map((p) =>
      parseInt(p.province_count_team)
    );
    provinceCountArray.push(parseInt(provinceCountTeam));

    if (_.sum(provinceCountArray) > matchStyle?.allowed_team) {
      return error("تعداد تیم انتخابی بیشتر از تعداد تیم مجاز است.");
    }
    if (parseInt(provinceCountPersonTeam) > matchStyle?.allowed_team_person) {
      return error("تعداد نفرات تیم انتخابی بیشتر از تعداد تیم مجاز است.");
    }
    let selectProvince = document.getElementById("select-age-team");
    if (provinceIdTeam === "all") {
      eventContext?.provinces?.forEach((p) => {
        const provinceIndex = provinceCpy.findIndex(
          (a) => a.province_id === p?.id
        );
        if (provinceIndex === -1) {
          provinceCpy.push({
            province_id: p?.id,
            title: p?.name,
            province_count_team: provinceCountTeam,
            province_count_person_team: provinceCountPersonTeam,
          });
        } else {
          provinceCpy[provinceIndex]["title"] = p?.name;
          provinceCpy[provinceIndex]["province_count_team"] = 1;
          provinceCpy[provinceIndex]["province_count_person_team"] =
            provinceCountPersonTeam;
        }
        for (let i = 0; i < selectProvince.length; i++) {
          if (selectProvince.options[i].value === `${p?.id}-${p?.name}`) {
            selectProvince.remove(i);
            selectProvince.options[1].selected = true;
            let val = selectProvince.value.split("-");
            setProvinceIdTeam(val[0]);
            setProvinceTitleTeam(val[1]);
            // setProvinceCountPersonTeam(provinceCountPersonTeam);
            // setProvinceCountTeam(provinceCountTeam);
          }
        }
      });
    } else {
      const provinceIndex = provinceCpy.findIndex(
        (a) => a.province_id === provinceIdTeam
      );

      if (provinceIndex === -1) {
        provinceCpy.push({
          province_id: provinceIdTeam,
          title: provinceTitleTeam,
          province_count_team: provinceCountTeam,
          province_count_person_team: provinceCountPersonTeam,
        });
      } else {
        provinceCpy[provinceIndex]["title"] = provinceTitleTeam;
        provinceCpy[provinceIndex]["province_count_team"] = provinceCountTeam;
        provinceCpy[provinceIndex]["province_count_person_team"] =
          provinceCountPersonTeam;
      }

      for (let i = 0; i < selectProvince.length; i++) {
        if (
          selectProvince.options[i].value ===
          `${provinceIdTeam}-${provinceTitleTeam}`
        ) {
          selectProvince.remove(i);
          selectProvince.options[1].selected = true;
          let val = selectProvince.value.split("-");
          setProvinceIdTeam(val[0]);
          setProvinceTitleTeam(val[1]);
          // setProvinceCountPersonTeam(provinceCountPersonTeam);
          // setProvinceCountTeam(provinceCountTeam);
        }
      }
    }

    // setProvinceIdTeam('');
    // setProvinceTitleTeam('');
    // setProvinceCountPersonTeam('');
    // setProvinceCountTeam('');
    setProvincesTeam(provinceCpy);
  };
  const editProvinceTeam = (provinceIndex, name, value) => {
    const provinceCpy = [...provincesTeam];
    provinceCpy[provinceIndex][name] = value;
    setProvincesTeam(provinceCpy);
  };

  const addAgeDouble = () => {
    if (
      priceDouble.length === 0 ||
      priceDouble === undefined ||
      ageIdDouble.length === 0 ||
      ageTitleDouble.length === 0
    ) {
      setErrorAgeDouble(true);
      return;
    }

    setErrorAge(false);
    let agesCpy = [...agesDouble];
    const ageIndex = agesCpy.findIndex((a) => a.age_id === ageIdDouble);

    if (ageIndex === -1) {
      agesCpy.push({
        age_id: ageIdDouble,
        person_price: priceDouble,
        title: ageTitleDouble,
      });
    } else {
      agesCpy[ageIndex]["person_price"] = priceDouble;
      agesCpy[ageIndex]["title"] = ageTitleDouble;
    }
    setPriceDouble("");
    setAgeIdDouble("");
    setAgeTitleDouble("");
    setAgesDouble(agesCpy);
  };
  const addProvinceDouble = () => {
    setErrorAgeDouble(false);
    let provinceCpy = [...provincesDouble];

    // if (provinceIdDouble === 0) {
    // 	eventContext.provinces.map((item) => {
    // 		const provinceIndex = provinceCpy.findIndex(
    // 			(a) => a.province_id === item.id,
    // 		);

    // 		if (provinceIndex === -1) {
    // 			provinceCpy.push({ province_id: item.id, title: item.name });
    // 		} else {
    // 			provinceCpy[provinceIndex]['title'] = item.name;
    // 		}
    // 	});

    // 	setProvincesDouble(provinceCpy);
    // 	return;
    // }

    const provinceIndex = provinceCpy.findIndex(
      (a) => a.province_id === provinceIdDouble
    );

    if (provinceIndex === -1) {
      provinceCpy.push({
        province_id: provinceIdDouble,
        title: provinceTitleDouble,
        province_count_person_double: provinceCountPersonDouble,
        province_count_double: provinceCountDouble,
      });
    } else {
      provinceCpy[provinceIndex]["title"] = provinceTitleDouble;
      provinceCpy[provinceIndex]["province_count_person_double"] =
        provinceCountPersonDouble;
      provinceCpy[provinceIndex]["province_count_double"] = provinceCountDouble;
    }
    let selectProvince = document.getElementById("select-age-double");
    for (let i = 0; i < selectProvince.length; i++) {
      if (
        selectProvince.options[i].value ===
        `${provinceIdDouble}-${provinceTitleDouble}`
      ) {
        selectProvince.remove(i);
        selectProvince.options[1].selected = true;
        let val = selectProvince.value.split("-");
        setProvinceIdDouble(val[0]);
        setProvinceTitleDouble(val[1]);
        // setProvinceCountPersonTeam(provinceCountPersonTeam);
        // setProvinceCountTeam(provinceCountTeam);
      }
    }
    // setProvinceIdDouble('');
    // setProvinceTitleDouble('');
    setProvincesDouble(provinceCpy);
  };

  const removeAge = (ageID) => {
    let ageCpy = [...ages];
    let agesFilter = ageCpy.filter((a) => a.age_id !== ageID);

    setAges(agesFilter);
  };
  const removeProvinceId = (provinceID) => {
    let provinceCpy = [...provinces];
    let provinceFind = provinceCpy.find((a) => a.province_id === provinceID);
    let provinceFilter = provinceCpy.filter((a) => a.province_id !== provinceID);

    let selectProvince = document.getElementById("select-age-one");
    var opt = document.createElement("option");
    opt.value = `${provinceID}-${provinceFind.title}`;
    opt.innerHTML = provinceFind.title;
    opt.selected = true;
    selectProvince.appendChild(opt);
    setProvinceId(provinceID);
    setProvinceTitle(provinceFind.title);

    setProvinces(provinceFilter);
  };


  const removeAgeTeam = (ageID) => {
    let ageCpy = [...agesTeam];
    let agesFilter = ageCpy.filter((a) => a.age_id !== ageID);
    setAgesTeam(agesFilter);
  };
  const removePostTeam = (postId) => {
    const postsCopy = [...postsTeam];
    setPostsTeam(postsCopy.filter((p) => p?.post_id !== postId));
  };
  const removeProvinceIdTeam = (provinceID) => {
    let provinceCpy = [...provincesTeam];
    let provinceFind = provinceCpy.find((a) => a.province_id === provinceID);
    let provinceFilter = provinceCpy.filter((a) => a.province_id !== provinceID);

    let selectProvince = document.getElementById('select-age-team');
    var opt = document.createElement('option');
    opt.value = `${provinceID}-${provinceFind.title}`;
    opt.innerHTML = provinceFind.title;
    opt.selected = true;
    selectProvince.appendChild(opt);
    setProvinceIdTeam(provinceID);
    setProvinceTitleTeam(provinceFind.title);

    setProvincesTeam(provinceFilter);
  };

  const removeAgeDouble = (ageID) => {
    let ageCpy = [...agesDouble];
    let agesFilter = ageCpy.filter((a) => a.age_id !== ageID);

    setAgesDouble(agesFilter);
  };
  const removeProvinceIdDouble = (provinceID) => {
    let provinceCpy = [...provincesDouble];
    let provinceFind = provinceCpy.find((a) => a.province_id === provinceID);
    let provinceFilter = provinceCpy.filter((a) => a.province_id !== provinceID);

    let selectProvince = document.getElementById("select-age-double");
    var opt = document.createElement("option");
    opt.value = `${provinceID}-${provinceFind.title}`;
    opt.innerHTML = provinceFind.title;
    opt.selected = true;
    selectProvince.appendChild(opt);
    setProvinceIdDouble(provinceID);
    setProvinceTitleDouble(provinceFind.title);
    setProvinceCountPersonDouble(provinceFind.province_count_person_double);
    setProvinceCountDouble(provinceFind.province_count_double);

    setProvincesDouble(provinceFilter);
  };

  const onSubmitForm = async (values, setSubmitting) => {
    let match_ages = [];
    let match_allowed_provinces = [];
    let match_posts = [];

    if (type.find((t) => t.name === "انفرادی") !== undefined) {
      if (ages.length === 0 || provinces.length === 0) {
        return error(
          "رده سنی و استان های مسابقات انفرادی نمی تواند خالی باشد."
        );
      }
      match_ages.push({
        type: "single",
        matchKind: type.find((t) => t.name === "انفرادی").id,
        items: ages,
      });
      match_allowed_provinces.push({
        type: "single",
        matchKind: type.find((t) => t.name === "انفرادی").id,
        provinces: provinces,
      });
    }
    if (type.find((t) => t.name === "تیمی") !== undefined) {
      if (agesTeam.length === 0 || provincesTeam.length === 0) {
        return error("رده سنی و استان های مسابقات تیمی نمی تواند خالی باشد.");
      }
      match_ages.push({
        type: "team",
        matchKind: type.find((t) => t.name === "تیمی").id,
        items: agesTeam,
      });
      match_allowed_provinces.push({
        type: "team",
        matchKind: type.find((t) => t.name === "تیمی").id,
        provinces: provincesTeam,
      });
      match_posts.push({
        type: "team",
        matchKind: type.find((t) => t.name === "تیمی").id,
        posts: postsTeam,
      });
    }
    if (type.find((t) => t.name === "دوبل") !== undefined) {
      if (agesDouble.length === 0 || provincesDouble.length === 0) {
        return error("رده سنی و استان های مسابقات دوبل نمی تواند خالی باشد.");
      }
      match_ages.push({
        type: "double",
        matchKind: type.find((t) => t.name === "دوبل").id,
        items: agesDouble,
      });
      match_allowed_provinces.push({
        type: "double",
        matchKind: type.find((t) => t.name === "دوبل").id,
        provinces: provincesDouble,
      });
    }
    values["match_ages"] = match_ages;
    values["match_allowed_provinces"] = match_allowed_provinces;
    values["match_posts"] = match_posts;

    if (values.match_ages.length === 0) {
      return error("یکی از لیست های انفرادی، تیمی و یا دوبل باید تکمیل شود");
    }
    if (values.registration_mode === "reserve_list") {
      const codes = String(values.reserve_national_codes || "").trim();
      if (!codes) {
        return error("در حالت لیست رزرو حداقل یک کد ملی وارد کنید.");
      }
    }
    setSubmitFormLoading(true);

    await useApi.put(
      `/panel/match/${id}`,
      values,
      (res) => {
        success("مسابقه با ویرایش ایجاد شد");
        getInfo();
        setSubmitFormLoading(false);
      },
      (err) => {
        setSubmitFormLoading(false);
        if (err?.status === 422 && err?.data?.errors) {
          showFirstRequestError(err.data.errors);
          return;
        }
        error(err?.data?.message || "خطایی در ثبت اطلاعات پیش آمده است.");
      }
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <Formik
        initialValues={{
          title: eventContext.match?.title,
          match_style_id: eventContext.match?.match_style?.id,
          match_kinds: (eventContext.match?.match_kinds || [])
            .slice(0, 1)
            .map((k) => k.id),
          province: eventContext.match?.province?.id,
          city: eventContext.match?.city?.id,
          register_start: moment(
            eventContext.match?.register_start ?? "1950-01-01",
            "YYYY-MM-DD  HH:mm:ss"
          )
            .locale("fa")
            .format("YYYY/MM/DD HH:mm:ss"),
          register_end: moment(
            eventContext.match?.register_end ?? "1950-01-01",
            "YYYY/MM/DD HH:mm:ss"
          )
            .locale("fa")
            .format("YYYY/MM/DD HH:mm:ss"),
          start: moment(eventContext.match?.start ?? "1950-01-01", "YYYY-MM-DD")
            .locale("fa")
            .format("YYYY/MM/DD"),
          end: moment(eventContext.match?.end ?? "1950-01-01", "YYYY-MM-DD")
            .locale("fa")
            .format("YYYY/MM/DD"),
          allowed_person: eventContext.match?.allowed_person,
          gender: eventContext.match?.gender,
          address: eventContext.match?.address,
          description: eventContext.match?.description,
          registration_mode: eventContext.match?.registration_mode || 'open',
          reserve_national_codes: (eventContext.match?.reserve_national_codes || []).join('\n'),
        }}
        onSubmit={(values, { setSubmitting }) => {
          onSubmitForm(values, setSubmitting);
        }}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="row border rounded mt-3">
              <div className="col-12">
                <div className="form-group">
                  <div className="d-flex flex-column mt-1 mx-2">
                    <label>عنوان مسابقه</label>
                    <input
                      name="title"
                      value={values.title}
                      onChange={handleChange}
                      type="text"
                      className="form-control"
                    />
                    <ErrorMessage error={errors.title} />
                  </div>
                </div>
              </div>
              {eventContext?.matchStyles?.length > 0 && (
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div className="form-group">
                    <div className="d-flex flex-column mt-1 mx-2">
                      <label>سبک برگزاری</label>
                      <Select
                        defaultValue={eventContext.match?.match_style}
                        options={eventContext.matchStyles}
                        onChange={(value) => {
                          setMatchStyle(value);
                          getMatchKindByMatchStyle(value.id);
                          setFieldValue("match_style_id", value.id, true);
                        }}
                        noOptionsMessage={() =>
                          "سبک برگزاری جهت انتخاب یافت نشد."
                        }
                        getOptionLabel={(c) => c.title}
                        getOptionValue={(c) => c.id}
                        className="w-100"
                        placeholder="انتخاب کنید..."
                      />

                      <ErrorMessage error={errors.match_style_id} />
                    </div>
                  </div>
                </div>
              )}
              {eventContext?.matchKinds?.length > 0 && (
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div className="form-group">
                    <div className="d-flex flex-column mt-1 mx-2">
                      <label>نوع مسابقه</label>
                      <Select
                        value={
                          values.match_kinds?.[0]
                            ? eventContext.matchKinds?.find(
                                (k) => k.id === values.match_kinds[0],
                              ) ?? null
                            : null
                        }
                        options={eventContext.matchKinds}
                        onChange={(value) => {
                          setType(value ? [value] : []);
                          setFieldValue(
                            "match_kinds",
                            value ? [value.id] : [],
                            true,
                          );
                        }}
                        noOptionsMessage={() =>
                          "نوع مسابقه جهت انتخاب یافت نشد."
                        }
                        getOptionLabel={(c) => c.name}
                        getOptionValue={(c) => c.id}
                        className="w-100"
                        placeholder="انتخاب کنید..."
                      />

                      <ErrorMessage error={errors.match_kinds} />
                    </div>
                  </div>
                </div>
              )}
              {eventContext?.provinces?.length > 0 && (
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div className="form-group">
                    <div className="d-flex flex-column mt-1 mx-2">
                      <label>استان محل برگزاری</label>
                      <Select
                        defaultValue={eventContext.match?.province}
                        options={eventContext.provinces}
                        onChange={(value) => {
                          getCities(value.id);
                          setFieldValue("province", value.id, true);
                        }}
                        noOptionsMessage={() =>
                          "نوع مسابقه جهت انتخاب یافت نشد."
                        }
                        getOptionLabel={(c) => c.name}
                        getOptionValue={(c) => c.id}
                        className="w-100"
                        placeholder="انتخاب کنید..."
                      />

                      <ErrorMessage error={errors.province} />
                    </div>
                  </div>
                </div>
              )}
              {eventContext?.cities?.length > 0 && (
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div className="form-group">
                    <div className="d-flex flex-column mt-1 mx-2">
                      <label>شهر محل برگزاری</label>
                      <Select
                        defaultValue={eventContext.match?.city}
                        options={eventContext.cities}
                        onChange={(value) => {
                          setFieldValue("city", value.id, true);
                        }}
                        noOptionsMessage={() =>
                          "نوع مسابقه جهت انتخاب یافت نشد."
                        }
                        getOptionLabel={(c) => c.name}
                        getOptionValue={(c) => c.id}
                        className="w-100"
                        placeholder="انتخاب کنید..."
                      />

                      <ErrorMessage error={errors.city} />
                    </div>
                  </div>
                </div>
              )}

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <div className="form-group">
                  <div className="d-flex flex-column mt-1 mx-2">
                    <label>شروع ثبت نام</label>
                    <Datepicker
                      handleChange={setFieldValue}
                      name="register_start"
                      format="YYYY/MM/DD HH:mm:ss"
                      showSelectTime={true}
                      value={values.register_start}
                    />
                    <ErrorMessage error={errors.register_start} />
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <div className="form-group">
                  <div className="d-flex flex-column mt-1 mx-2">
                    <label>پایان ثبت نام</label>
                    <Datepicker
                      handleChange={setFieldValue}
                      name="register_end"
                      format="YYYY/MM/DD HH:mm:ss"
                      showSelectTime={true}
                      value={values.register_end}
                    />
                    <ErrorMessage error={errors.register_end} />
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="form-group">
                  <div className="d-flex flex-column mt-1 mx-2">
                    <label>نوع ثبت‌نام</label>
                    <select
                      name="registration_mode"
                      className="form-control"
                      value={values.registration_mode}
                      onChange={handleChange}
                    >
                      <option value="open">عادی (همه واجد شرایط)</option>
                      <option value="reserve_list">لیست رزرو</option>
                    </select>
                  </div>
                </div>
              </div>

              {values.registration_mode === "reserve_list" && (
                <div className="col-12">
                  <div className="form-group">
                    <div className="d-flex flex-column mt-1 mx-2">
                      <label>کدهای ملی لیست رزرو (هر کد در یک خط)</label>
                      <textarea
                        name="reserve_national_codes"
                        className="form-control"
                        rows={6}
                        value={values.reserve_national_codes}
                        onChange={handleChange}
                      />
                      <small className="text-muted mt-1">
                        فقط کاربران موجود در سیستم با حق عضویت معتبر می‌توانند ثبت‌نام کنند.
                      </small>
                    </div>
                  </div>
                </div>
              )}

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <div className="form-group">
                  <div className="d-flex flex-column mt-1 mx-2">
                    <label>شروع برگزاری</label>
                    <Datepicker
                      handleChange={setFieldValue}
                      name="start"
                      value={values.start}
                    />
                    <ErrorMessage error={errors.start} />
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <div className="form-group">
                  <div className="d-flex flex-column mt-1 mx-2">
                    <label>پایان برگزاری</label>
                    <Datepicker
                      handleChange={setFieldValue}
                      name="end"
                      value={values.end}
                    />
                    <ErrorMessage error={errors.end} />
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group">
                  <div className="d-flex flex-column mt-1 mx-2">
                    <label>ظرفیت</label>
                    <input
                      name="allowed_person"
                      value={values.allowed_person}
                      onChange={handleChange}
                      type="text"
                      className="form-control"
                    />
                    <ErrorMessage error={errors.allowed_person} />
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="form-group">
                  <div className="d-flex flex-column mt-1 mx-2">
                    <label>جنسیت</label>
                    <select
                      className="form-control"
                      name="gender"
                      onChange={handleChange}
                      value={values.gender}
                    >
                      <option>انتخاب کنید</option>
                      <option value="1">مرد</option>
                      <option value="2">زن</option>
                      <option value="3">مشترک</option>
                    </select>
                    <ErrorMessage error={errors.gender} />
                  </div>
                </div>
              </div>
              {type.find((t) => t.name === "انفرادی") !== undefined && (
                <>
                  <div className="col-12">
                    <h1 className="flex flex-column border-bottom pb-2 my-2 f-14">
                      انفرادی
                    </h1>
                  </div>

                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    {eventContext.ages?.length > 0 && (
                      <div className="col-12">
                        <div className="form-group">
                          <label>انتخاب رده سنی</label>
                          <div className="d-flex flex-row justify-content-between">
                            <select
                              id="select-age"
                              className={`form-control ${
                                errorAge && "border-danger"
                              }`}
                              onChange={(e) => {
                                let value = e.target.value.split("-");
                                setAgeId(value?.[0]);
                                setAgeTitle(value?.[1]);
                              }}
                            >
                              <option selected={true} disabled={true}>
                                رده سنی
                              </option>
                              {eventContext.ages?.map((item) => (
                                <option
                                  key={item.id}
                                  value={item.id + "-" + item.title}
                                >
                                  {item.title}
                                </option>
                              ))}
                            </select>
                            <input
                              onChange={(e) => setPrice(e.target.value)}
                              type="text"
                              value={price}
                              placeholder="هزینه انفرادی (ریال)"
                              className={`form-control mx-1 ${
                                errorAge && "border-danger"
                              }`}
                            />

                            <i
                              onClick={() => addAge()}
                              className="fad fa-plus-circle f-20 text-success mx-2 mt-2 c-pointer"
                            ></i>
                          </div>
                          {ages?.map((item) => (
                            <div
                              className="d-flex flex-row justify-content-between my-2"
                              key={item.id}
                            >
                              <input
                                disabled
                                type="text"
                                className="form-control mx-1"
                                value={item.title}
                              />
                              <input
                                disabled
                                type="text"
                                className="form-control mx-1"
                                value={number_format(item.person_price)}
                              />

                              <i
                                onClick={() => removeAge(item.age_id)}
                                className="fad fa-minus-circle f-20 text-danger mx-2 mt-2 c-pointer"
                              ></i>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  {eventContext.provinces?.length > 0 && (
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <div className="form-group">
                        <label>انتخاب استان های مجاز </label>
                        <div className="d-flex flex-row justify-content-between">
                          <select
                            id="select-age-one"
                            className="form-control"
                            onChange={(e) => {
                              let value = e.target.value.split("-");
                              setProvinceId(value?.[0]);
                              setProvinceTitle(value?.[1]);
                            }}
                          >
                            <option selected={true} disabled={true}>
                              انتخاب استان
                            </option>
                            <option value="all-all">همه</option>

                            {eventContext.provinces?.map((item) => (
                              <option
                                key={item.id}
                                value={item.id + "-" + item.name}
                              >
                                {item.name}
                              </option>
                            ))}
                          </select>

                          <i
                            onClick={() => addProvince()}
                            className="fad fa-plus-circle f-20 text-success mx-2 mt-2 c-pointer"
                          ></i>
                        </div>
                        {provinces.length > 0 && (
                          <div
                            className="overflow-auto border border-info p-2 my-2 rounded"
                            style={{ maxHeight: "200px" }}
                          >
                            {provinces?.map((item) => (
                              <div
                                className="d-flex flex-row my-2"
                                key={item.id}
                              >
                                <div className="d-flex flex-row">
                                  <input
                                    disabled
                                    type="text"
                                    className="form-control mx-1"
                                    value={item.title}
                                  />
                                </div>
                                <i
                                  onClick={() =>
                                    removeProvinceId(item.province_id)
                                  }
                                  className="fad fa-minus-circle f-20 text-danger mx-2 mt-2 c-pointer"
                                ></i>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </>
              )}

              {type.find((t) => t.name === "تیمی") !== undefined && (
                <>
                  <div className="col-12">
                    <h1 className="flex flex-column border-bottom pb-2 my-2 f-14">
                      تیمی
                    </h1>
                  </div>
                  {eventContext.ages?.length > 0 && (
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <div className="col-12">
                        <div className="form-group">
                          <label>انتخاب رده سنی</label>
                          <div className="d-flex flex-row justify-content-beetween">
                            <select
                              id="select-age"
                              className={`form-control ${
                                errorAgeTeam && "border-danger"
                              }`}
                              onChange={(e) => {
                                let value = e.target.value.split("-");
                                setAgeIdTeam(value?.[0]);
                                setAgeTitleTeam(value?.[1]);
                              }}
                            >
                              <option selected={true} disabled={true}>
                                رده سنی
                              </option>
                              {eventContext.ages?.map((item) => (
                                <option
                                  key={item.id}
                                  value={item.id + "-" + item.title}
                                >
                                  {item.title}
                                </option>
                              ))}
                            </select>
                            <input
                              onChange={(e) => setPriceTeam(e.target.value)}
                              type="text"
                              value={priceTeam}
                              placeholder="هزینه تیمی (ریال)"
                              className={`form-control mx-1 ${
                                errorAgeTeam && "border-danger"
                              }`}
                            />

                            <i
                              onClick={() => addAgeTeam()}
                              className="fad fa-plus-circle f-20 text-success mx-2 mt-2 c-pointer"
                            ></i>
                          </div>
                          {agesTeam?.map((item) => (
                            <div
                              className="d-flex flex-row justify-content-between my-2"
                              key={item.id}
                            >
                              <input
                                disabled
                                type="text"
                                className="form-control mx-1"
                                value={item.title}
                              />
                              <input
                                disabled
                                type="text"
                                className="form-control mx-1"
                                value={number_format(item.person_price)}
                              />

                              <i
                                onClick={() => removeAgeTeam(item.age_id)}
                                className="fad fa-minus-circle f-20 text-danger mx-2 mt-2 c-pointer"
                              ></i>
                            </div>
                          ))}
                        </div>
                      </div>
                      {eventContext.posts?.length > 0 && (
                        <div className="col-12">
                          <div className="form-group">
                            <label>انتخاب سمت</label>
                            <div className="d-flex flex-row justify-content-between">
                              <select
                                id="select-post-team"
                                className={`form-control w-50 ${
                                  errorPostTeam && "border-danger"
                                }`}
                                onChange={(e) => {
                                  let value = e.target.value.split("-");
                                  setPostIdTeam(value?.[0]);
                                  setPostTitleTeam(value?.[1]);
                                }}
                              >
                                <option selected={true} disabled={true}>
                                  سمت
                                </option>
                                {eventContext.posts?.map((item) => (
                                  <option
                                    key={item.id}
                                    value={item.id + "-" + item.title}
                                  >
                                    {item.title}
                                  </option>
                                ))}
                              </select>
                              <input
                                onChange={(e) =>
                                  setPostCountTeam(e.target.value)
                                }
                                type="number"
                                value={postCountTeam}
                                placeholder="تعداد"
                                className={`form-control mx-1  w-50 ${
                                  errorPostTeam && "border-danger"
                                }`}
                              />

                              <i
                                onClick={() => addPostTeam()}
                                className="fad fa-plus-circle f-20 text-success mx-2 mt-2 c-pointer"
                              ></i>
                            </div>
                            {postsTeam?.map((item) => (
                              <div
                                className="d-flex flex-row justify-content-between my-2"
                                key={item.id}
                              >
                                <input
                                  disabled
                                  type="text"
                                  className="form-control mx-1"
                                  value={item.title}
                                />
                                <input
                                  disabled
                                  type="text"
                                  className="form-control mx-1"
                                  value={item.count}
                                />

                                <i
                                  onClick={() => removePostTeam(item.post_id)}
                                  className="fad fa-minus-circle f-20 text-danger mx-2 mt-2 c-pointer"
                                ></i>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {eventContext.provinces?.length > 0 && (
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <div className="form-group">
                        <label>انتخاب استان های مجاز </label>
                        <div className="d-flex flex-row">
                          <div className="d-flex flex-row justify-content-between">
                            <select
                              id="select-age-team"
                              className="form-control w-100"
                              onChange={(e) => {
                                let value = e.target.value.split("-");
                                setProvinceIdTeam(value?.[0]);
                                setProvinceTitleTeam(value?.[1]);
                              }}
                            >
                              <option selected={true} disabled={true}>
                                انتخاب استان
                              </option>
                              <option value="all-all">همه</option>

                              {eventContext.provinces?.map((item) => (
                                <option
                                  key={item.id}
                                  value={item.id + "-" + item.name}
                                >
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <input
                            type="text"
                            className="form-control w-30"
                            onChange={(e) =>
                              setProvinceCountTeam(e.target.value)
                            }
                            value={provinceCountTeam}
                            placeholder="تعداد تیم"
                          />
                          <input
                            type="text"
                            className="form-control w-30"
                            onChange={(e) =>
                              setProvinceCountPersonTeam(e.target.value)
                            }
                            value={provinceCountPersonTeam}
                            placeholder="تعداد افراد تیم"
                          />
                          <i
                            onClick={() => addProvinceTeam()}
                            className="fad fa-plus-circle f-20 text-success mx-2 mt-2 c-pointer"
                          ></i>
                        </div>
                        {provincesTeam.length > 0 && (
                          <div
                            className="overflow-auto border border-info p-2 my-2 rounded"
                            style={{ maxHeight: "200px" }}
                          >
                            <div className="d-flex flex-row my-2 justify-content-around">
                              <label>استان</label>
                              <label>تعداد تیم</label>
                              <label>تعداد افراد تیم</label>
                            </div>
                            {provincesTeam?.map((item, index) => (
                              <div
                                className="d-flex flex-row my-2"
                                key={item.id}
                              >
                                <div className="d-flex flex-row">
                                  <input
                                    disabled
                                    type="text"
                                    className="form-control mx-1"
                                    value={item.title}
                                  />
                                  <input
                                    onChange={(e) =>
                                      editProvinceTeam(
                                        index,
                                        "province_count_team",
                                        e.target.value
                                      )
                                    }
                                    type="text"
                                    className="form-control mx-1"
                                    value={item.province_count_team}
                                  />
                                  <input
                                    onChange={(e) =>
                                      editProvinceTeam(
                                        index,
                                        "province_count_person_team",
                                        e.target.value
                                      )
                                    }
                                    type="text"
                                    className="form-control mx-1"
                                    value={item.province_count_person_team}
                                  />
                                </div>
                                <i
                                  onClick={() =>
                                    removeProvinceIdTeam(item.province_id)
                                  }
                                  className="fad fa-minus-circle f-20 text-danger mx-2 mt-2 c-pointer"
                                ></i>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </>
              )}

              {type.find((t) => t.name === "دوبل") !== undefined && (
                <>
                  <div className="col-12">
                    <h1 className="flex flex-column border-bottom pb-2 my-2 f-14">
                      دوبل
                    </h1>
                  </div>
                  {eventContext.ages?.length > 0 && (
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <div className="col-12">
                        <div className="form-group">
                          <label>انتخاب رده سنی</label>
                          <div className="d-flex flex-row justify-content-between">
                            <select
                              id="select-age"
                              className={`form-control ${
                                errorAgeDouble && "border-danger"
                              }`}
                              onChange={(e) => {
                                let value = e.target.value.split("-");
                                setAgeIdDouble(value?.[0]);
                                setAgeTitleDouble(value?.[1]);
                              }}
                            >
                              <option selected={true} disabled={true}>
                                رده سنی
                              </option>
                              {eventContext.ages?.map((item) => (
                                <option
                                  key={item.id}
                                  value={item.id + "-" + item.title}
                                >
                                  {item.title}
                                </option>
                              ))}
                            </select>
                            <input
                              onChange={(e) => setPriceDouble(e.target.value)}
                              type="text"
                              value={priceDouble}
                              placeholder="هزینه دوبل (ریال)"
                              className={`form-control mx-1 ${
                                errorAgeDouble && "border-danger"
                              }`}
                            />

                            <i
                              onClick={() => addAgeDouble()}
                              className="fad fa-plus-circle f-20 text-success mx-2 mt-2 c-pointer"
                            ></i>
                          </div>
                          {agesDouble?.map((item) => (
                            <div
                              className="d-flex flex-row justify-content-around my-2"
                              key={item.id}
                            >
                              <div className="d-flex flex-row">
                                <input
                                  disabled
                                  type="text"
                                  className="form-control mx-1"
                                  value={item.title}
                                />
                                <input
                                  disabled
                                  type="text"
                                  className="form-control mx-1"
                                  value={number_format(item.person_price)}
                                />
                              </div>
                              <i
                                onClick={() => removeAgeDouble(item.age_id)}
                                className="fad fa-minus-circle f-20 text-danger mx-2 mt-2 c-pointer"
                              ></i>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                  {eventContext.provinces?.length > 0 && (
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <div className="form-group">
                        <label>انتخاب استان های مجاز </label>
                        <div className="d-flex flex-row">
                          <div className="d-flex flex-row">
                            <select
                              id="select-age-double"
                              className="form-control"
                              onChange={(e) => {
                                let value = e.target.value.split("-");
                                setProvinceIdDouble(value?.[0]);
                                setProvinceTitleDouble(value?.[1]);
                              }}
                            >
                              <option selected={true} disabled={true}>
                                انتخاب استان
                              </option>

                              {eventContext.provinces?.map((item) => (
                                <option
                                  key={item.id}
                                  value={item.id + "-" + item.name}
                                >
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <input
                            type="text"
                            className="form-control w-30"
                            onChange={(e) =>
                              setProvinceCountDouble(e.target.value)
                            }
                            value={provinceCountDouble}
                            placeholder="تعداد تیم"
                          />
                          <input
                            type="text"
                            className="form-control w-30"
                            disabled
                            value="2"
                            placeholder="تعداد افراد تیم"
                          />
                          <i
                            onClick={() => addProvinceDouble()}
                            className="fad fa-plus-circle f-20 text-success mx-2 mt-2 c-pointer"
                          ></i>
                        </div>
                        {provincesDouble.length > 0 && (
                          <div
                            className="overflow-auto border border-info p-2 my-2 rounded"
                            style={{ maxHeight: "200px" }}
                          >
                            <div className="d-flex flex-row my-2 justify-content-around">
                              <label>استان</label>
                              <label>تعداد تیم</label>
                              <label>تعداد افراد تیم</label>
                            </div>
                            {provincesDouble?.map((item, index) => (
                              <div
                                className="d-flex flex-row my-2"
                                key={item.id}
                              >
                                <div className="d-flex flex-row">
                                  <input
                                    disabled
                                    type="text"
                                    className="form-control mx-1"
                                    value={item.title}
                                  />

                                  <input
                                    onChange={(e) =>
                                      editProvinceTeam(
                                        index,
                                        "province_count_team",
                                        e.target.value
                                      )
                                    }
                                    type="text"
                                    className="form-control mx-1"
                                    value={item.province_count_double}
                                  />
                                  <input
                                    disabled
                                    type="text"
                                    className="form-control mx-1"
                                    value={item.province_count_person_double}
                                  />
                                </div>
                                <i
                                  onClick={() =>
                                    removeProvinceIdDouble(item.province_id)
                                  }
                                  className="fad fa-minus-circle f-20 text-danger mx-2 mt-2 c-pointer"
                                ></i>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </>
              )}

              <div className="col-12">
                <div className="form-group">
                  <div className="d-flex flex-column mt-1 mx-2">
                    <label>آدرس محل برگزاری</label>
                    <textarea
                      className="form-control"
                      name="address"
                      value={values.address}
                      onChange={handleChange}
                    ></textarea>
                    <ErrorMessage error={errors.address} />
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="form-group">
                  <div className="d-flex flex-column mt-1 mx-2">
                    <label>توضیحات</label>
                    <TextEditor
                      name="description"
                      value={values?.description}
                      setFieldValue={setFieldValue}
                    />
                    <ErrorMessage error={errors.description} />
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="d-flex flex-row justify-content-end my-3">
                  <button
                    disabled={submitFormLoading}
                    className="btn btn-info btn-sm f-14"
                  >
                    {submitFormLoading ? (
                      <div
                        className="spinner-border spinner-border-sm text-white mb-1"
                        role="status"
                      ></div>
                    ) : (
                      "ویرایش مسابقه"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </Master>
  );
};

export default EditMatch;
